const targetNode = document.getElementsByTagName('body')[0];
const config = { childList: true };

if (targetNode !== null) {
  const callback = function(mutationList) {
    if ($('#mod-top-bar').length) {
      observer.disconnect();

      $('#mod-top-bar').appendTo('#nav-lang');
    }
  };

  let observer = new MutationObserver(callback);

  observer.observe(targetNode, config);
}



// WEBPACK FOOTER //
// ./../src/assets/js/languages.js